import SvgIcon from "@mui/material/SvgIcon";
import ThreeDIconSvg from "../live-svg/three-d-icon.svg";
import React from "react";

export function ThreeDIcon(props) {
    return (
        <SvgIcon {...props}>
            <ThreeDIconSvg color={props.color || "#36415D"}/>
        </SvgIcon>
    )
}
